import React, { useState } from "react";

function CampbellFAQs() {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleAccordionClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const isActive = (index) => activeIndex === index;

  const faqs = [
    {
      question: "What types of junk do you remove in Campbell?",
      answer:
        "We handle a wide variety of items, including old furniture, appliances, mattresses, construction debris, yard waste, scrap metal, electronics, and more. Whether it's residential or commercial junk, our team can help remove almost anything from your property.",
    },
    {
      question: "Do you offer same-day junk removal in Campbell, CA?",
      answer:
        "Yes! We offer same-day junk removal services for most jobs. Just give us a call, and we’ll schedule a pickup as soon as possible.",
    },
    {
      question: "How much does junk removal in Campbell cost?",
      answer:
        "Our prices depend on the volume of junk and the type of items you need removed. However, we offer competitive pricing and free junk removal estimates to ensure there are no surprises. Upfront pricing ensures you know exactly what to expect.",
    },
    {
      question: "Do you provide free estimates for junk removal?",
      answer:
        "Yes, we offer free estimates for junk removal. Just give us a call or fill out our online form, and we’ll provide an accurate quote based on the amount of junk and the specific services required.",
    },
    {
      question: "How can I schedule junk removal services in Campbell?",
      answer:
        "Scheduling is easy! You can call us directly or fill out the online form on our website. We offer flexible scheduling to meet your needs, including same-day service and next-day service.",
    },
    {
      question: "What happens to the junk after it’s removed?",
      answer:
        "We’re committed to responsible disposal. Our team uses eco-friendly junk removal methods, recycling or donating as much as possible. We ensure that your junk doesn’t end up in a landfill unnecessarily.",
    },
    {
      question: "Do you remove construction debris in Campbell, CA?",
      answer:
        "Yes, we specialize in construction debris removal. Whether you're dealing with scrap metal, building materials, or general construction waste, our team can handle it all.",
    },
    {
      question:
        "Do you offer services for both residential and commercial junk removal?",
      answer:
        "Absolutely! We provide residential junk removal services for homeowners and renters, as well as commercial junk removal for businesses, office cleanouts, and other commercial properties.",
    },
    {
      question: "How long does junk removal in Campbell take?",
      answer:
        "The time it takes to remove junk depends on the amount of junk and the complexity of the job. However, most jobs can be completed in under 2 hours. If you're in a hurry, ask about same-day junk removal.",
    },
    {
      question: "Can I schedule junk removal for just one item?",
      answer:
        "Yes, we can help you remove a single item or a large volume of junk. Whether it’s a single mattress, old appliance, or a pile of furniture, we offer junk removal for all types of projects.",
    },
    {
      question: "Do you charge extra for items like electronics or appliances?",
      answer:
        "We offer competitive pricing, and certain items like old appliances or electronics may come with a small additional fee. However, we will always provide you with an upfront quote, so you know exactly what to expect.",
    },
    {
      question: "How can I pay for junk removal services in Campbell?",
      answer:
        "We accept a variety of payment methods, including credit cards and cash. We strive to make the payment process easy and convenient for you.",
    },
  ];

  return (
    <div>
      <main>
        <div className="accordion junk-faq-sec">
          {faqs.map((faq, index) => (
            <div
              className={`accordion-item ${isActive(index) ? "active" : ""}`}
              key={index}
            >
              <div
                className="accordion-item-header"
                onClick={() => handleAccordionClick(index)}
                style={{ color: isActive(index) ? "blue" : "#000" }}
              >
                <span className="accordion-item-header-title">
                  <img
                    src={
                      isActive(index)
                        ? "/assets/img/question-mark-yellow.svg"
                        : "/assets/img/_Compound Path_.png"
                    }
                    alt="default"
                    loading="lazy"
                    className="accordion-image"
                  />
                  <p>{faq.question}</p>
                </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-chevron-down"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                    style={{ color: isActive(index) ? "#2d6bd6" : "#000" }}
                  />
                </svg>
              </div>
              <div
                className={`accordion-item-description-wrapper ${
                  isActive(index) ? "open" : ""
                }`}
                style={{ display: isActive(index) ? "block" : "none" }}
              >
                <div className="accordion-item-description">
                  <p>{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}

export default CampbellFAQs;
